export default __webpack_public_path__ + "static/media/Animals21.44d28f24.jpg";